<template>
  <confirm-action-dialog
    v-model="deleteAvailabilityDialog"
    heading-color="error"
    :title="t('smpw.delete_availability')"
    :message="t('shift.deletion.message_1', { date: toLongDateWithDay(date) })"
    :confirm-label="t('actions.delete')"
    confirm-color="error"
    method="delete"
    :url="`/api/users/${user.id}/shifts/availability`"
    :params="{ date: toUniversalDate(date) }"
    :success-message="t('shift.deletion.success_message')"
    :error-message="t('shift.deletion.error_message')"
    @confirmed="emit('availability:deleted', date)"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import ConfirmActionDialog from '@/components/crud/ConfirmActionDialog.vue';
import { useDate } from '@/composables';

defineProps<{
  date?: NullableDateOptionType;
  user: App.Models.User;
}>();

const emit = defineEmits(['availability:deleted']);

const { t } = useI18n();

const deleteAvailabilityDialog = defineModel<boolean>({ default: false });

const {
  toUniversalDate,
  toLongDateWithDay,
} = useDate();
</script>
